import { Button, Card, Col, DatePicker, Form, Input, message, Modal, Popconfirm, Row, Select, Spin, Table } from "antd"
import { ColumnsType } from 'antd/es/table';
import FileUpload, { FileUploadRef } from "../../../../components/file-input/FileUpload"
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../../api/axiosInstance";
import { DeleteOutlined, EditOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { User } from "../../../../services/users/user";
import FilterHelper from "../../../../utils/Filters/FilterHelper";
import { FilterRequest, OrderTypes, OrderValue } from "../../../../utils/Filters/FilterModels";
import { TableRowSelection } from "antd/es/table/interface";
import dayjs from "dayjs";
const { TextArea } = Input;
const { Option } = Select;

const API_URL = process.env.REACT_APP_API_URL;

const ClubDetailManagement = () => {
    const { clubID } = useParams();

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isAddMemberModal, setIsAddMemberModal] = useState(false);
    const fileUploadRef = useRef<FileUploadRef>(null);
    const [imagePath, setImagePath] = useState<string>();
    const [hasNewImage, setHasNewImage] = useState(false);
    const [formClub] = Form.useForm();
    const [formAddListMember] = Form.useForm();
    const [listMember, setListMember] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [listUser, setListUsers] = useState<any[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const rowSelection: TableRowSelection<any> = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys, selectedRows) => {
            setSelectedRowKeys(newSelectedRowKeys);
        },
    };

    const [filter, setFilter] = useState<FilterRequest>(new FilterRequest({
        page: 1,
        limit: 1000,
        keyword: '',
        summary: '',
        filters: [],
        orders: [new OrderValue({ propertyName: 'userCode', type: OrderTypes.Desc, index: 0 })
        ],
        isFull: false,
        tree: false,
    }));
    const listMemberColumns: ColumnsType<any> = [
        { title: "clubDetailID", dataIndex: "clubDetailID", key: "clubDetailID", hidden: true },
        {
            title: "Mã người dùng",
            dataIndex: "userCode",
            key: "userCode",
            align: 'center',
            width: 170,
        },
        { title: "NickName", dataIndex: "nickName", key: "nickName" },
        { title: "Họ tên", dataIndex: "fullName", key: "fullName" },
        { title: "Giới tính", align: 'center', dataIndex: "gender", key: "gender", render: (text: any) => (text === 0 ? "Nam" : text === 1 ? "Nữ" : ""), },
        { title: "Điểm đơn", dataIndex: "point", key: "point" },
        { title: "Điểm đôi", dataIndex: "doublePoint", key: "doublePoint" },
        { title: "Chức vụ", dataIndex: "position", key: "position", render: (text: any, record: any) => { let color = record.position === 0 ? "#F42121" : record.position === 1 ? "#F48100" : "#07BD74"; return <span style={{ color }}>{(text === 0 ? "Thành viên" : text === 1 ? "Phó chủ tịch" : "Chủ tịch")}</span> } },
        {
            title: "Hoạt động",
            key: "actions",
            render: (record: any) => (
                <>
                    <Button type="link" icon={<EditOutlined />} onClick={() => handlerEditMember(record)} />
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa?"
                        onConfirm={() => handleDeleteListMember(record)}
                        okText="Có"
                        cancelText="Không"
                    >
                        <Button type="link" icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </>
            ),
        },
    ];

    useEffect(() => {
        if (clubID) {
            fetchClubData();
            fetchListMemberData();

        }
        const observer = new ResizeObserver(() => { });
        return () => observer.disconnect();
    }, [clubID]);

    const handleUploadSuccess = (newPath: string) => {
        setImagePath(newPath);
        setHasNewImage(false);
    };

    const handleUpload = async (): Promise<string | null> => {
        if (hasNewImage) {
            return await fileUploadRef.current?.uploadFile() || null;
        }
        return imagePath?.toString() ?? null;
    };
    // Lấy dữ liệu
    const fetchClubData = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/v1/club/${clubID}`);
            const data = response.data;
            data.establishmentDate = dayjs(data.establishmentDate)
            formClub.setFieldsValue(data);
            setImagePath(data.attachmentFile)
            setData(data)
        } catch (error) {
            message.error("Không thể tải thông tin câu lạc bộ!");
        }
    };
    const fetchListMemberData = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/v1/club/list-member/${clubID}`);
            const listMember = response.data;
            setListMember(listMember);
        } catch (error) {
            // message.error("Không thể tải thông tin thành viên của câu lạc bộ!");
        }
    };

    const getListUser = async (isCreate?: boolean) => {
        try {
            const params = FilterHelper.getParamWithFilter(filter);

            const response = await axiosInstance.get("/user", {
                params: params,
            });
            const users = response.data?.list || [];
            const formattedData: User[] = users.map((item: any) => ({
                id: item.id,
                userCode: item.userCode,
                dateOfBirth: item.dateOfBirth,
                fullName: item.fullName || "Không có tên",
                gender: item.gender || "Nam",
                point: item.point || "Chưa có điểm",
                nickName: item.nickName || "Không xác định",
            }));
            const listUsers = formattedData.filter(a => !listMember.some(b => b.userID === a.id));
            setListUsers(isCreate === true ? listUsers : formattedData)
        } catch (error) {
            // message.error("Không thể tải danh sách người dùng!");
        }
    };
    // Thêm người dùng
    const handlerAddMember = () => {
        formAddListMember.resetFields();
        getListUser(true);
        setIsAddMemberModal(true);
    };
    const handlerEditMember = async (record: any) => {
        await getListUser();
        await axiosInstance.get(`${API_URL}/v1/club/get-club-detail/${record.clubDetailID}`).then((response) => {
            const data = response.data;
            formAddListMember.setFieldsValue({
                clubDetailID: data.clubDetailID,
                userID: data.userID,
                nickName: listMember.find((item: any) => item.userID === data.userID)?.nickName,
                position: data.position
            });
            setIsAddMemberModal(true);
        })
    };
    const handleReloadListMember = () => {
        fetchListMemberData();
    };

    const handleShowDeleteClubDetailModal = () => {
        if (selectedRowKeys.length > 0) {
            setIsModalVisible(true);
        }
        else {
            message.error("Vui lòng chọn ít nhẩt 1 bản ghi!");
        }
    }
    const handleCancelDeleteClubDetailModal = () => setIsModalVisible(false);
    const handleDeleteMultiListMember = async () => {
        if (selectedRowKeys.length > 0) {
            try {
                await axiosInstance.put(`${API_URL}/v1/club/delete-list-member`, { clubDetailIds: selectedRowKeys });
                message.success("Xoá thành viên thành công!");
                setSelectedRowKeys([]);
                fetchListMemberData();
                setIsModalVisible(false);
            }
            catch (error: any) {
                message.error(error.response?.data);
            }
            finally {
                setSelectedRowKeys([]);
            }
        } else {
            message.error("Vui lòng chọn ít nhẩt 1 bản ghi!");
        }

    };

    const handleDeleteListMember = async (record: any) => {
        try {
            await axiosInstance.put(`${API_URL}/v1/club/delete-list-member`, { clubDetailIds: [record.clubDetailID] });
            message.success("Xoá thành viên thành công!");
            fetchListMemberData();
        }
        catch (error: any) {
            message.error(error.response?.data);
        }
    }

    const handleCloseModalAddMember = () => {
        setIsAddMemberModal(false);
    }
    const handlerSaveAddMember = async () => {
        try {
            const values = await formAddListMember.validateFields();

            const payload = {
                userID: values.nickName,
                position: values.position,
                status: 1,
                clubID: clubID,
            };

            await axiosInstance.post(`${API_URL}/v1/club/cms/member-join`, payload);

            message.success("Thêm người dùng thành công!");
            fetchListMemberData();
            formAddListMember.resetFields();
            setIsAddMemberModal(false);
        } catch (error: any) {
            if (error?.errorFields) {
                return
            } else {
                message.error(error?.response?.data?.data || "Có lỗi xảy ra khi thêm người dùng.");
            }
        }
    };


    const handleCancel = () => {
        navigate("/club-management");
    };

    const handleConfirm = async () => {
        try {
            const newImagePath = await handleUpload();

            const values = formClub.getFieldsValue();
            const payLoad = {
                clubCode: values.clubCode,
                clubName: values.clubName,
                address: values.address,
                facebook: values.facebook,
                zalo: values.zalo,
                phoneNumber: values.phoneNumber,
                introduction: values.introduction,
                establishmentDate: values.establishmentDate.format("YYYY-MM-DD"),
                contact: values.contact,
                playTime: values.playTime,
                attachmentFile: newImagePath
            };
            if (!clubID) {
                await axiosInstance.post(`${API_URL}/v1/club/create-club/`, payLoad);

                message.success("Tạo mới câu lạc bộ thành công!");
            } else {
                await axiosInstance.put(`${API_URL}/v1/club/update-club/${clubID}`, payLoad);

                message.success("Cập nhật câu lạc bộ thành công!");
            }

            navigate("/club-management");
        }
        catch (error: any) {
            message.error(error?.response.data.data);
        }
    };
    return (
        <div style={{ padding: "20px" }}>
            <Form layout="vertical" form={formClub}>
                <Card>
                    <div className="p-6 bg-white rounded-lg shadow-md">
                        <h3 className="text-lg font-semibold mb-4">Thông tin chung</h3>
                        <Row gutter={16}>
                            <Col span={24} className="flex justify-center items-center">
                                <div style={{ marginBottom: 20, height: 200 }}>
                                    <FileUpload
                                        expectedWidth={2560}
                                        expectedHeight={1440}
                                        width={376}
                                        height={240}
                                        ref={fileUploadRef}
                                        unit="club" type="image"
                                        initialFilePath={imagePath}
                                        onUploadSuccess={handleUploadSuccess}
                                        onFileSelected={() => setHasNewImage(true)} />
                                </div>
                            </Col>
                            <Col span={24}>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item label={<strong>Mã câu lạc bộ</strong>} name="clubCode" rules={[
                                            { required: true, message: 'Vui lòng nhập mã người dùng' },
                                            { min: 6, max: 6, message: 'Mã phải đúng 6 ký tự' },
                                        ]}>
                                            <Input placeholder="Nhập mã câu lạc bộ" maxLength={6} minLength={6} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={16}>
                                        <Form.Item label={<strong>Tên câu lạc bộ</strong>} name="clubName">
                                            <Input placeholder="Nhập tên câu lạc bộ" />
                                        </Form.Item>
                                    </Col>

                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item label={<strong>Ngày thành lập</strong>} name="establishmentDate">
                                            <DatePicker placeholder="Chọn ngày" style={{ width: "100%" }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={16}>
                                        <Form.Item label={<strong>Giờ sinh hoạt CLB</strong>} name="playTime">
                                            <Input placeholder="Nhập giờ sinh hoạt CLB" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={16}>
                                        <Form.Item label={<strong>Facebook</strong>} name="facebook">
                                            <Input placeholder="https://www.facebook.com" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item label={<strong>Số Zalo</strong>} name="zalo">
                                            <Input placeholder="Nhập số Zalo" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item label={<strong>Số điện thoại</strong>} name="phoneNumber">
                                            <Input placeholder="Nhập số điện thoại" />
                                        </Form.Item>
                                    </Col>

                                </Row>

                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item label={<strong>Giới thiệu</strong>} name="introduction">
                                            {/* <CKEditor
                                                editor={ClassicEditor}
                                                data={formClub.getFieldValue("introduction")}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    formClub.setFieldsValue({ introduction: data });
                                                }}
                                            /> */}
                                            <TextArea rows={4} placeholder="Nhập giới thiệu" />
                                        </Form.Item>
                                    </Col>
                                </Row >
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item label={<strong>Địa điểm</strong>} name="address">
                                            {/* <CKEditor
                                                editor={ClassicEditor}
                                                data={formClub.getFieldValue("address")}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    formClub.setFieldsValue({ address: data });
                                                }}
                                            /> */}
                                            <TextArea rows={4} placeholder="Nhập địa điểm" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item label={<strong>Liên hệ</strong>} name="contact">
                                            {/* <CKEditor
                                                editor={ClassicEditor}
                                                data={formClub.getFieldValue("contact")}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    formClub.setFieldsValue({ contact: data });
                                                }}
                                            /> */}
                                            <TextArea rows={4} placeholder="Nhập liên hệ" />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Card title="Danh sách thành viên câu lạc" style={{ marginBottom: 16 }}>
                                    <Button type="primary" icon={<PlusOutlined />} style={{ marginBottom: 10, backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={handlerAddMember}>Thêm mới</Button>
                                    <Button icon={<DeleteOutlined />} danger style={{ marginLeft: 10, marginBottom: 10 }} onClick={handleShowDeleteClubDetailModal}>Xoá</Button>
                                    <Button icon={<ReloadOutlined />} style={{ marginLeft: 10, marginBottom: 10 }} onClick={handleReloadListMember}>Làm mới</Button>
                                    {loading ? (
                                        <Spin fullscreen tip="Đang tải dữ liệu..." size="large" />
                                    ) : (<Table rowKey={(record) => record.clubDetailID} rowSelection={rowSelection} dataSource={listMember} columns={listMemberColumns} pagination={false} scroll={{ y: 500 }}
                                    />)}
                                </Card>
                                <Modal
                                    title="Xác nhận xoá thành viên"
                                    open={isModalVisible}
                                    onOk={handleDeleteMultiListMember}
                                    onCancel={handleCancelDeleteClubDetailModal}
                                    okText="Xoá"
                                    cancelText="Huỷ"
                                    okButtonProps={{ danger: true }}
                                >
                                    <p>Bạn có chắc muốn xoá {selectedRowKeys.length} thành viên đã chọn?</p>
                                </Modal>
                            </Col>
                        </Row>
                    </div>
                    <Modal
                        title=
                        "Thêm mới thành viên"
                        visible={isAddMemberModal}
                        width={600}
                        onCancel={handleCloseModalAddMember}
                        footer={[
                            <Button key="cancel" onClick={handleCloseModalAddMember} style={{ backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }}>
                                Thoát
                            </Button>,
                            <Button key="submit" type="primary" style={{ backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={handlerSaveAddMember}>
                                Lưu
                            </Button>,
                        ]}
                    >
                        <Form form={formAddListMember} layout="vertical">
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="Thành viên" name="nickName" rules={[
                                        { required: true, message: 'Vui lòng chọn thành viên' }]}>
                                        <Select showSearch
                                            filterOption={(input, option) => {
                                                const children = option?.children ?? '';
                                                const text =
                                                    typeof children === 'string'
                                                        ? children
                                                        : Array.isArray(children)
                                                            ? children.join('')
                                                            : String(children);
                                                return text.toLowerCase().includes(input.toLowerCase());
                                            }}
                                            placeholder="Chọn thành viên">
                                            {listUser.map(athlete => (
                                                <Option key={athlete.nickName} value={athlete.id}>
                                                    {athlete.userCode} - {athlete.nickName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Chức vụ" name="position" rules={[{ required: true, message: 'Vui lòng chọn chức vụ' }]}>
                                        <Select placeholder="Chọn chức vụ">
                                            <Option value={0}>Thành viên</Option>
                                            <Option value={1}>Phó chủ tịch</Option>
                                            <Option value={2}>Chủ tịch</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Modal>
                </Card>
            </Form>
            <div style={{ display: "flex", justifyContent: "end", marginTop: 16, marginRight: 20 }}>
                <Button style={{ marginRight: 10, backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} onClick={handleCancel}>Huỷ</Button>
                <Button style={{ marginBottom: 10, backgroundColor: "#F48100", borderColor: "#F48100" }} type="primary" onClick={handleConfirm}>Xác nhận</Button>
            </div>
        </div>
    )
}
export default ClubDetailManagement